import { Stack, styled, Typography, type CSSObject } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledSection = styled(Section)(() => ({
  position: 'relative',
}));

export const StyledSectionTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  width: '100%',
  letterSpacing: '-0.02em',
  paddingBottom: theme.spacing(5),
  display: 'flex',
  justifyContent: 'left',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    justifyContent: 'center',
  },
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  width: '100%',
  maxWidth: '1300px',
  letterSpacing: '-0.02em',
  paddingBottom: theme.spacing(5),
  display: 'flex',
  fontSize: '2rem',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '1.5rem',
  },
}));

export const StyledContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: theme.spacing(10),
}));
